import React, {Component} from 'react';


import {connect} from 'react-redux';
import {searchActions, searchSelectors} from "../../store/search";
import {schoolSelectors} from "../../store/school";
import {chatActions} from "../../store/chat";

import Layout from '../../components/Layout'
import NewChat from '../../pages/Chat/NewChat'
 
import Loading from '../../components/Base/Loading'

/* Container for New Posts page */

class NewChatContainer extends Component {
	constructor(props) {
		super(props);

		this.state = {
			width: 0,
			height: 0,
			students: [],
			faculty: [],
			loading: false

		};
	}

	componentDidMount() {
		this.setState({loading: true});
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);

		this.studentListener = this.getStudentListener();
		this.facultyListener = this.props.firebase.faculties().orderBy('last_name', 'asc').onSnapshot(snapshot => {
				let result = [];
				snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
				this.setState({faculty: result, loading: false})
			}
		) 
	}

	getStudentListener = () => {
		return this.props.firebase.students().orderBy('last_name', 'asc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
			this.props.updateStudents(result)
			this.setState({students: result, loading: false})
		});
	}

	updateWindowDimensions = () => {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	}

	componentWillUnmount() {
		 this.studentListener();
		 this.facultyListener();
	}

	render() {
		const {loading, faculty} = this.state;
		const {width, students} = this.state;
		const { profile } = this.props;
		return (
			<Layout {...this.props} noSideBar noFooter>
			{
				loading || profile === null ? <Loading />
				:
				<NewChat {...this.props} loading={loading} students={students} faculty={faculty} width={width}/>
			}
			</Layout>
		);
	}
}

const mapStateToProps = state => ({
	loadingSchool: schoolSelectors.isLoading(state.school),
	schoolInfo: schoolSelectors.refreshSchool(state.school),
	search: searchSelectors.refreshSearch(state.search),
	loading: searchSelectors.isLoading(state.search),
});

const mapDispatchToProps = dispatch => ({
	updateChatId: (id) => {
		dispatch(chatActions.updateCurrentChat(id))
	}, 
	clearSearch: () => {
		dispatch(searchActions.clearSearch());
	},
	updateStudents: (students) => {
		dispatch(searchActions.updateStudents(students))
	}
});


export default connect(mapStateToProps, mapDispatchToProps)(NewChatContainer);
